import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('Faq?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('Faq/show/'+id);
    },    
    create(params) {
        return Service().post('Faq/create', params);
    },
    update(id, params) {
        return Service().post('Faq/update/'+id, params);
    },
    delete(id) {
        return Service().post('Faq/delete/'+id);
    }
}